import React from 'react';
import { connect } from 'react-redux';
import { IControlProps, MapProps } from '../';
import { IDataStorage } from '../../../core';
import Translate from '../../../core/translate';
import { ICliente, IClienteEmailTemplate } from '../../../services/api/entity/model';
import { GetStyleEmailTemplateTipos } from '../../../services/emailtemplates';
import { IPaginatedResponse } from '../../../services/model';
import GridComponent, { getDataFromArray, Index as Grid, IPagination, SelectModes } from '../../grid';
import { Button, Chips, Dialog, TabPanel, TabView } from '../../prime';
import styles from './selectemailtemplate.module.scss';

enum ClienteVendedorStatus {
  Disponible = "disponible",
  Denegado = "denegado",
  Eliminado = "eliminado",
  Huerfano = "huerfano"
}

interface IData {
  loaded: boolean;
  list: IClienteEmailTemplate[];  
}

interface IProps extends IControlProps<IClienteEmailTemplate[]> { 
  storage?: IDataStorage;
  cliente?: ICliente;
}

interface IState extends IControlProps<IClienteEmailTemplate[]> {
  storage?: IDataStorage;

  /** Cliente principal */
  cliente?: ICliente;

  /** Indica el mensaje de error si es que existe */
  validError?: string;

  data?: IData;
  
  modal?: {
    show?: number;
  }
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  grid: Grid | null = null;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => undefined);
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p?.storage;
    if (p?.cliente !== s?.cliente) res.cliente = p?.cliente;
    if (p?.value !== s?.value) res.data = Index.extractComponentData(p);
    return MapProps(res, p, s);
  }

  static extractComponentData = (p?: IProps) : any => {
    if (!p?.value) return undefined;
    
    let list = (p.value ?? []).filter(p => p.tipo === 'cliente'); // los del cliente van siempre
    list.push(...(p.value ?? []).filter(p => p.tipo === 'herencia' && p.id < 0 && !list.find(l => l.emailtemplate.id === p.emailtemplate.id ) )); // los heredados editados en este control
    list.push(...(p.value ?? []).filter(p => p.tipo === 'herencia' && !list.find(l => l.emailtemplate.id === p.emailtemplate.id ) )); // resto de los heredados 
    list.push(...(p.value ?? []).filter(p => p.tipo === 'huerfano' && !!p.cliente?.id && !list.find(l => l.emailtemplate.id === p.emailtemplate.id ) )); // los huerfanos que ya fueron asignados
    list.push(...(p.value ?? []).filter(p => p.tipo === 'huerfano' && !p.cliente?.id && !list.find(l => l.emailtemplate.id === p.emailtemplate.id ) )); // los huerfanos que no fueron asignados
    list = list.map(obj => {
      let status = ClienteVendedorStatus.Disponible;
      if (obj.tipo === 'huerfano' && !obj.cliente?.id) status = ClienteVendedorStatus.Huerfano;
      else if (p.cliente?.id === obj.cliente?.id && !!obj.bajafecha) status = ClienteVendedorStatus.Eliminado;
      else if (obj.deny) status = ClienteVendedorStatus.Denegado;
      (obj as any).status = status;
      return obj;
    })

    return {
      loaded: true, 
      list
    } as IData;
  }

  getGridData = (pag?: IPagination | undefined, sort?: string | undefined, filters?: any) : Promise<IPaginatedResponse<IClienteEmailTemplate>> =>
    getDataFromArray(pag, sort, filters, this.state.data?.list ?? [], rows => {
      const { modal } = this.state;

      if (modal?.show === 0) rows = rows.filter(row => row.status === ClienteVendedorStatus.Disponible);
      else if (modal?.show === 1) rows = rows.filter(row => [ClienteVendedorStatus.Denegado, ClienteVendedorStatus.Eliminado].includes(row.status) );
      else if (modal?.show === 2) rows = rows.filter(row => row.status === ClienteVendedorStatus.Huerfano);
      else rows = [];

      if (!!filters && !!filters["cliente.nombre"]) rows = rows.filter(row => new RegExp(filters["cliente.nombre"].value, 'i').test(row.cliente.nombre) );
      if (!!filters && !!filters["email.tipo"]) rows = rows.filter(row => new RegExp(filters["email.tipo"].value, 'i').test(row.emailtemplate.tipo) );
      if (!!filters && !!filters["email.subject"]) rows = rows.filter(row => new RegExp(filters["email.subject"].value, 'i').test(row.emailtemplate.subject) );
      return rows;
    });

  render() {
    const { validError, data, modal } = this.state;
    const t = Translate.get("components/forms/cliente/selectemailtemplate", this.state.storage?.languaje);
        
    const grid =
      <GridComponent
        selectMode={SelectModes.single}
        name="component//cliente/selectemailtemplate"
        syncGrid={e => this.grid = e}
        data={this.getGridData}
        columns={[
          this.state.modal?.show !== 2 ? { order: 1, field: 'cliente.nombre', header: t('Modal.Grid.cliente'), sortable: true, filter: true, filterPlaceholder: t("Modal.Grid.cliente.Placeholder") } : undefined,
          { order: 2, field: 'emailtemplate.tipo', header: t('Modal.Grid.tipo'), sortable: true, filter: true, filterPlaceholder: t("Modal.Grid.tipo.Placeholder"),
            body: (row,col) => <span className='p-tag p-badge-l' 
              style={GetStyleEmailTemplateTipos(row.emailtemplate.tipo)}
            >{row.emailtemplate.tipo}</span>,
            export: row => row.emailtemplate.tipo
          },
          { order: 3, field: 'emailtemplate.subject', header: t('Modal.Grid.subject'), sortable: true, filter: true, filterPlaceholder: t("Modal.Grid.subject.Placeholder") },
          this.state.modal?.show !== 0 ? { order: 4, field: 'status', header: t('Modal.Grid.status'), sortable: true, filter: true, filterPlaceholder: t("Modal.Grid.status.Placeholder"),
            body: row => <>
              {row.status === ClienteVendedorStatus.Disponible && <>{t('Modal.Grid.status.Activo')}</> }
              {row.status === ClienteVendedorStatus.Eliminado && <>{t('Modal.Grid.status.Eliminado')}</> }
              {row.status === ClienteVendedorStatus.Denegado && <>{t('Modal.Grid.status.Denegado')}</> }
              {row.status === ClienteVendedorStatus.Huerfano && <>{t('Modal.Grid.status.Disponible')}</> }
            </>,
            export: row => {
              if (row.status === ClienteVendedorStatus.Disponible) return t('Modal.Grid.status.Activo');
              if (row.status === ClienteVendedorStatus.Eliminado) return t('Modal.Grid.status.Eliminado');
              if (row.status === ClienteVendedorStatus.Denegado) return t('Modal.Grid.status.Denegado');
              if (row.status === ClienteVendedorStatus.Huerfano) return t('Modal.Grid.status.Disponible');
            }
          } : undefined,
        ]}
        columnCommandsWidth="65px"
        columnCommands={this.state.disabled ? [] : [
          { icon:"fa fa-ban", tooltip:t('Modal.Grid.Action.Deny'), className:"p-button-rounded p-button-danger p-button-text", hide: row => row.status !== ClienteVendedorStatus.Disponible, onClick:row => this.ObjChange('delete', row) },
          { icon:"fas fa-check", tooltip:t('Modal.Grid.Action.Allow'), className:"p-button-rounded p-button-success p-button-text", hide: row => row.status === ClienteVendedorStatus.Disponible, onClick:row => this.ObjChange('add', row) }
        ]}
      />;

    return (
      <>
        <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
          {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
          <div className={`${styles.addons} p-inputgroup`}>
            {this.state.required && 
              <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
                <i className="pi pi-exclamation-circle" />
              </span>
            }
            <Chips 
              value={(data?.list ?? []).filter(row => (row as any).status === ClienteVendedorStatus.Disponible).map(p => p.emailtemplate.tipo)}
              disabled
            />
            <Button 
              icon={this.state.disabled ? 'pi pi-eye' : 'pi pi-search'} 
              className="p-button-primary" 
              onClick={() => this.setState({ modal: { show: 0 } })} 
              tooltip={this.state.disabled ? t("Open.Ver.Tooltip") : t("Open.Editar.Tooltip")}
              tooltipOptions={{position:'top'}} 
            />
          </div>
          {validError && <span className={styles.errordesc}>{validError}</span>}
        </div>
        <Dialog 
          modal
          header={<><span className="fas fa-briefcase" /> {t(`Modal.Tab.Titulo.${this.state.modal?.show}`)}</>}
          style={{width: '70%'}}
          footer={
            <div style={{ fontSize: '.8em' }}>
              <span style={{float:'left', fontSize:'1.7em'}} />
              <Button label={t('Modal.Cerrar')} className="p-button-secondary" onClick={() => this.setState({ modal: undefined })} tooltip={t('Modal.Cerrar.Tooltip')} tooltipOptions={{position:'top'}} />
            </div>
          }
          visible={!!modal} 
          dismissableMask
          onHide={() => this.setState({ modal: undefined })}
        >
          <TabView activeIndex={this.state.modal?.show ?? 1} onTabChange={e => this.setState({ modal: { ...modal, ...{ show: e.index } } })}>
            <TabPanel header={t("Modal.Tab.0")} leftIcon="fas fa-check" headerClassName={styles['tab-allow']}>{modal?.show === 0 && grid}</TabPanel>
            <TabPanel header={t("Modal.Tab.1")} leftIcon="fas fa-ban" headerClassName={styles['tab-deny']}>{modal?.show === 1 && grid}</TabPanel>
            <TabPanel header={t("Modal.Tab.2")} leftIcon="fas fa-briefcase" headerClassName={styles['tab-orphan']}>{modal?.show === 2 && grid}</TabPanel>
          </TabView>
        </Dialog>
      </>
    );
  }

  ObjChange = (accion: string, row: IClienteEmailTemplate) => {
    let { value } = this.state;
    const { cliente } = this.state;

    const getNewId = () => ( (value ?? []).sort((a,b) => a.id - b.id)[0]?.id ?? 0 ) - 1;
    if (!value || (value ?? []).length < 1) return;
    switch (accion) {
      case 'delete':
        switch (row.tipo) {
          case 'cliente':
            const obj = value.find(p => p.id === row.id);
            if (obj) { obj.bajafecha = new Date(); obj.updated = true }
            this.change(value);
            break;
          case 'herencia':
            if (row.updated)
              value = value.filter(p => p.id !== row.id);
            else
              value.push({ id: getNewId(), updated: true, cliente: { id: cliente?.id, nivel: cliente?.nivel, nombre: cliente?.nombre, bajafecha: cliente?.bajafecha }, deny: true, allow: false, tipo: 'herencia', bajafecha: undefined, emailtemplate: { ...row.emailtemplate } } as IClienteEmailTemplate);
            this.change(value);
            break;
          case 'huerfano':
            value = value.filter(p => p.id !== row.id);
            this.change(value);
            break;
        }
        break;

      case 'add':
        switch (row.tipo) {
          case 'cliente':
            const obj = value.find(p => p.id === row.id);
            if (obj) { obj.bajafecha = undefined; obj.allow = true; obj.deny = false; obj.updated = true }
            this.change(value);
            break;
          case 'herencia':
            if (row.updated)
              value = value.filter(p => p.id !== row.id);
            else 
              value.push({ id: getNewId(), updated: true, cliente: { id: cliente?.id, nivel: cliente?.nivel, nombre: cliente?.nombre, bajafecha: cliente?.bajafecha }, deny: false, allow: true, tipo: 'herencia', bajafecha: undefined, emailtemplate: { ...row.emailtemplate } } as IClienteEmailTemplate);
            this.change(value);
            break;
          case 'huerfano':
            const newRow = { id: getNewId(), updated: true, cliente: { id: cliente?.id, nivel: cliente?.nivel, nombre: cliente?.nombre, bajafecha: cliente?.bajafecha }, deny: false, allow: true, tipo: 'huerfano', bajafecha: undefined, emailtemplate: { ...row.emailtemplate } } as IClienteEmailTemplate;
            value.push(newRow);
            this.change(value);
            break;
        }
        break;
    }
  }

  change = (newvalue: IClienteEmailTemplate[]) => {
    const { onChange } = this.props;

    newvalue = [ ...newvalue ];
    this.setState({ data: { loaded: true, list: newvalue }}, () => this.grid?.refresh());

    if (onChange) onChange(newvalue, undefined);

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
